
import { formatTimestampView } from '../utils/functions';
import './BasicTable.css'

export const BasicYarnColumns = [
    /*{
        // aus den columns id entfernen, wenn sie nicht in der Tabelle erscheinen soll
        Header: 'Id', 
        accessor: 'id_basic_yarn',
        disableFilters: true, // Filtermoeglichkeit für id entfernt
        sticky: 'left' // Spalte links fixieren
    },*/
    {
        Header: 'Bezeichnung',
        accessor: 'name',
        sticky: 'left' // Spalte links fixieren
    },
    {
        Header: 'Letzte Änderung',
        accessor: 'timestamp',
        Cell: ({ value }) => formatTimestampView(value),
            sortType: (rowB, rowA) => {
            // Direktes Vergleichen der Timestamp-Werte für korrektes Sortieren
            const timestampA = rowA.values.timestamp;
            const timestampB = rowB.values.timestamp;

            return new Date(timestampB) - new Date(timestampA);
        }
    },
    {
        Header: 'Hersteller',
        accessor: 'manufacturer_name', // dropdown
    },
    {
        Header: 'Institution',
        accessor: 'institution_name', // wird nur in Tabelle angezeigt
    },
    {
        Header: 'Gesamtdurchmesser',
        accessor: (row) => {
            // Kombiniere Durchmesser und Einheit
            const diameter = row.diameter;
            const unit = row.unit_diameter_name;
            if (!diameter && !unit) return null; // Fallback, falls Werte fehlen            
            return `${diameter} ${unit}`;
          },
        
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);           
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurück
            return floatValue < 0 ? '' : value;
        },
        sortType: (rowA, rowB) => {
            const convertToMM = (valueWithUnit) => {
                if (!valueWithUnit) return 0; // Fallback für fehlende Werte
                const [value, unit] = valueWithUnit.split(" ");
                const diameter = parseFloat(value);
                if (isNaN(diameter)) return 0; // Fallback für ungültige Werte
                switch (unit) {
                    case "mm":
                        return diameter * 1000 ; // 1 mm = 1000 µm
                    case "µm":
                        return diameter; // bereits in µm
                    default:
                        return diameter; // Fallback
                }
            };
            const mmsA = convertToMM(rowA.values['Gesamtdurchmesser']);
            const mmsB = convertToMM(rowB.values['Gesamtdurchmesser']);           
            return mmsA - mmsB;
        },

        /*accessor: row => `${row.diameter} ${row.unit_diameter_name}`,
        disableSortBy: true,
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);
            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurück
            return floatValue < 0 ? '' : value;
        },*/
    },
    {
        Header: 'Feinheit',
        accessor: (row) => {
            // Kombiniere Feinheit und Einheit
            const yarn_fineness = row.yarn_fineness;
            const unit = row.unit_yarn_fineness_name;
            if (!yarn_fineness && !unit) return null; // Fallback, falls Werte fehlen            
            return `${yarn_fineness} ${unit}`;
          },
        
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);           
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurück
            return floatValue < 0 ? '' : value;
        },
        sortType: (rowA, rowB) => {
            const convertToMM = (valueWithUnit) => {
                if (!valueWithUnit) return 0; // Fallback für fehlende Werte
                const [value, unit] = valueWithUnit.split(" ");
                const yarn_fineness = parseFloat(value);
                if (isNaN(yarn_fineness)) return 0; // Fallback für ungültige Werte
                switch (unit) {
                    case "tex":
                        return yarn_fineness * 10; // 1 tex = 10 dtex
                    case "dtex":
                        return yarn_fineness; // bereits in dtex
                    default:
                        return yarn_fineness; // Fallback
                }
            };
            const mmsA = convertToMM(rowA.values['Feinheit']);
            const mmsB = convertToMM(rowB.values['Feinheit']);           
            return mmsA - mmsB;
        },
        
        
        /*accessor: row => `${row.yarn_fineness} ${row.unit_yarn_fineness_name}`,
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);
            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurück
            return floatValue < 0 ? '' : value;
        },*/
    },
    {
        Header: 'Material',
        accessor: 'material_name', // dropdown - vorhanden für alle Materialien
    },
    {
        Header: 'eigenes Material',
        accessor: 'material_own', // Textfeld zur Eingabe von Materialien, die nicht in Material enthalten sind
    },
    {
        Header: 'Aufbau',
        accessor: 'structure_name', // dropdown
    },
    {
        Header: 'Rauigkeit/Struktur',
        accessor: 'surface_structure', // Textfeld zur Eingabe von rauh, glatt, ...   
    },
    {
        Header: 'Waschbarkeit',
        accessor: row => `${row.washability_cycles}`,
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const numericValue = parseInt(value);
            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurück
            return numericValue < 0 ? '' : value;
        },
    },
    {
        Header: 'UV-Beständigkeit',
        accessor: 'uv_resistance',
    },
    {
        Header: 'Flexibilität',
        accessor: row => `${row.flexibility} ${row.unit_flexibility_name}`,
        disableSortBy: true,
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);
            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurück
            return floatValue < 0 ? '' : value;
        },
    },
    {
        Header: 'Max. zulässige Temperatur',
        accessor: (row) => {
            // Kombiniere Temperatur und Einheit
            const max_temperature = row.max_temperature;
            const unit = row.unit_max_temperature_name;
            if (!max_temperature && !unit) return null; // Fallback, falls Werte fehlen            
            return `${max_temperature} ${unit}`;
          },
        
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurück
            return floatValue < 0 ? '' : value;
        },
        sortType: (rowA, rowB) => {
            const convertToMM = (valueWithUnit) => {
                if (!valueWithUnit) return 0; // Fallback für fehlende Werte
                const [value, unit] = valueWithUnit.split(" ");
                const max_temperature = parseFloat(value);
                if (isNaN(max_temperature)) return 0; // Fallback für ungültige Werte
                switch (unit) {
                    case "°C":
                        return max_temperature + 273 ; // 1 mm = 1000 µm
                    case "K":
                        return max_temperature; // bereits in K
                    default:
                        return max_temperature; // Fallback
                }
            };
            const mmsA = convertToMM(rowA.values['Max. zulässige Temperatur']);
            const mmsB = convertToMM(rowB.values['Max. zulässige Temperatur']);           
            return mmsA - mmsB;
        },

        /*accessor: row => `${row.max_temperature} ${row.unit_max_temperature_name}`,
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);
            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurück
            return floatValue < 0 ? '' : value;
        },*/

    },
    {
        Header: 'Sonstige',
        accessor: 'others',
    },
    {
        Header: (
            <div style={{ transform: 'rotate(-90deg)', width: '45px', height: '40px', textAlign: 'left' }}>
                Rezept Anzahl
            </div>
        ),
        accessor: 'count_in_recipe',
        disableFilters: true, // Filtermöglichkeit für id entfernt
    }
]
